module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_six-7e582b4a63ebdc722728dee0593c4a88.jpg";